import * as React from 'react'

const Exclamation = (props:any) =>(
  <svg {...props} viewBox='0 0 16 16'>
    <path fill='#444' d='M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z'
    />
    <path fill='#444' d='M7 3h2v7h-2v-7z' />
    <path fill='#444' d='M7 11h2v2h-2v-2z' />
  </svg>
)

export default Exclamation;


// WEBPACK FOOTER //
// ./src/components/icons/ui/Exclamation.tsx